import React from "react";
import FaceBookIcon from "../../assets/Mask Group 2.png";
import { useNavigate } from "react-router-dom";

function GenreCard({ title, img }) {
  let navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate(`/detail`);
        window.scrollTo(0, 0);
      }}
      className={` rounded-lg bg-white  w-full  py-5 px-5 flex flex-col	justify-between`}
    >
      <div className="flex items-center justify-between">
        <div>
          <img src={img} className="h-14 pb-2 -ml-0.5" alt="facebook" />
        </div>
        <div>
          <div className="font-bold text-lg">{title}</div>
          <div className="text-right text-sm text-gray-500">OTT</div>
        </div>
      </div>
      <div className="mt-2">
        <div className="flex  ">
          <p className="text-sm  pl-1  text-primary">user</p>
          <p className="text-sm text-gray-500 pl-3 ">
            100 Mn+ Monthly Active Users
          </p>
        </div>
        <div className="flex mt-2">
          <p className="text-sm  pl-1 text-primary">tag</p>
          <p className="text-sm text-gray-500 pl-3">Rs. 30,000 Min Spend</p>
        </div>
      </div>
    </div>
  );
}

export default GenreCard;
